export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'memeGenerator', getter: () => import(/* webpackChunkName: "memeGenerator" */ 'components/bolt/memeGenerator/memeGenerator'), component: 'memeGenerator', parent: 'boltHome' }
];
